<template>
    <div class="addCustomFieldArea">
        <div class="row m-0 customFieldTable">
            <div class="col-12 pl-0 pr-0">
                <div class="row m-0">
                    <div class="col-20 border-left-0">
                        <div class="row m-0 bg-new-light">
                            <div class="col-12">
                                <div class="pt-3 pb-3">
                                    <h3 class="font-family-bold text-center color-gray f-14 m-0">{{$ml.get('OPPORTUNITIES')}}</h3>
                                </div>
                            </div>
                        </div>
                        <div class="row m-0 h-100">
                            <div class="col-12">
                                <div class="row p-2">
                                    <div class="col-12 p-0"> 
                                        <ul class="customList p-0" id="1">
                                            <template v-for="i in customFields" :key="i._id ? i._id.$oid : i.name">
                                                <li class="d-flex box-shadow bg-white border-radius-4 mt-2" v-if='i.domain===1'>
                                                    <div class="col-10 p-2 float-left" data-toggle="modal" data-target="#updateCustomField" @click="updateCustomFieldSettings(i._id.$oid,i.name,i.field_type,i.options)">
                                                        <p class="f-13 btn-click mb-1" :title="i.name">{{filterName(i.name)}}</p>
                                                        <label class="f-13 float-left color-gray">{{typeConvert(i, $ml)}}</label>
                                                    </div>
                                                    <div class="col-2 p-2 pt-2 d-flex align-items-center deleteIcon">
                                                        <i @click="deleteId=i._id.$oid" data-toggle="modal" data-target="#deleteCustomField" class="fa fa-close btn-click"></i>
                                                    </div>
                                                </li>
                                            </template>
                                        </ul>
                                    </div>
                                </div>                             
                            </div>
                        </div>                     
                    </div>
                    <div class="col-20">
                        <div class="row m-0 bg-new-light">
                            <div class="col-12">
                                <div class="pt-3 pb-3">
                                    <h3 class="font-family-bold text-center color-gray f-14 m-0">{{$ml.get('ACTIVITIES')}}</h3>
                                </div>
                            </div>
                        </div>
                        <div class="row  m-0 h-100">
                            <div class="col-12">
                                <div class="row p-2">
                                    <div class="col-12 p-0"> 
                                        <ul class="customList p-0" id="2">
                                            <template v-for="i in customFields" :key="i._id ? i._id.$oid : i.name">
                                                <li class="d-flex box-shadow bg-white border-radius-4 mt-2" :id="i._id ? i._id.$oid : ''" v-if="i.domain===5 || i.domain===6 || i.domain===7 || i.domain===8">
                                                    <div class="col-10 p-2 float-left" data-toggle="modal" data-target="#updateCustomField" @click="updateCustomFieldSettings(i._id.$oid,i.name,i.field_type,i.options)">
                                                        <p class="f-13 btn-click mb-1" :title="i.name">{{filterName(i.name)}}</p>
                                                        <label class="f-13 float-left color-gray">{{typeConvert(i, $ml)}}</label>
                                                    </div>
                                                    <div class="col-2 p-2 pt-2 d-flex align-items-center deleteIcon">
                                                        <i @click="deleteId=i._id.$oid" data-toggle="modal" data-target="#deleteCustomField" class="fa fa-close btn-click"></i>
                                                    </div>
                                                </li>
                                            </template>
                                        </ul>
                                    </div>
                                </div>                             
                            </div>
                        </div>                     
                    </div>
                    <div class="col-20">
                        <div class="row  m-0 bg-new-light">
                            <div class="col-12">
                                <div class="col-12">
                                    <div class="pt-3 pb-3">
                                        <h3 class="font-family-bold text-center color-gray f-14 m-0">{{$ml.get('COMPAINES')}}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row  m-0 h-100">
                            <div class="col-12">
                                <div class="row p-2">
                                    <div class="col-12 p-0"> 
                                        <ul class="customList p-0" id="3">
                                            <template v-for="i in customFields" :key="i._id ? i._id.$oid : i.name">
                                                <li class="d-flex box-shadow bg-white border-radius-4 mt-2" :id="i._id ? i._id.$oid : ''" v-if="i.domain===2">
                                                    <div class="col-10 p-2 float-left" data-toggle="modal" data-target="#updateCustomField" @click="updateCustomFieldSettings(i._id.$oid,i.name,i.field_type,i.options)">
                                                        <p class="f-13 btn-click mb-1" :title="i.name">{{filterName(i.name)}}</p>
                                                        <label class="f-13 float-left color-gray">{{typeConvert(i, $ml)}}</label>
                                                    </div>
                                                    <div class="col-2 p-2 pt-2 d-flex align-items-center deleteIcon">
                                                        <i @click="deleteId=i._id.$oid" data-toggle="modal" data-target="#deleteCustomField" class="fa fa-close btn-click"></i>
                                                    </div>
                                                </li>
                                            </template>
                                        </ul>
                                    </div>
                                </div>                             
                            </div>
                        </div>                     
                    </div>
                    <div class="col-20">
                        <div class="row  m-0 bg-new-light">
                            <div class="col-12">
                                <div class="col-12">
                                    <div class="pt-3 pb-3">
                                        <h3 class="font-family-bold text-center color-gray f-14 m-0">{{$ml.get('PERSONS')}}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row  m-0 h-100" >
                            <div class="col-12">
                                <div class="row p-2">
                                    <div class="col-12 p-0"> 
                                        <ul class="customList p-0" id="4">
                                            <template v-for="i in customFields" :key="i._id ? i._id.$oid : i.name">
                                                <li class="d-flex box-shadow bg-white border-radius-4 mt-2" :id="i._id ? i._id.$oid : ''" v-if="i.domain===3">
                                                    <div class="col-10 p-2 float-left" data-toggle="modal" data-target="#updateCustomField" @click="updateCustomFieldSettings(i._id.$oid,i.name,i.field_type,i.options)">
                                                        <p class="f-13 btn-click mb-1" :title="i.name">{{filterName(i.name)}}</p>
                                                        <label class="f-13 float-left color-gray">{{typeConvert(i, $ml)}}</label>
                                                    </div>
                                                    <div class="col-2 p-2 pt-2 d-flex align-items-center deleteIcon">
                                                        <i @click="deleteId=i._id.$oid" data-toggle="modal" data-target="#deleteCustomField" class="fa fa-close btn-click"></i>
                                                    </div>
                                                </li>
                                            </template>
                                        </ul>
                                    </div>
                                </div>                             
                            </div>
                        </div>                     
                    </div>
                    <div class="col-20 border-right-0">
                        <div class="row  m-0 bg-new-light">
                            <div class="col-12">
                                <div class="col-12">
                                    <div class="pt-3 pb-3">
                                        <h3 class="font-family-bold text-center color-gray f-14 m-0">{{$ml.get('PRODUCTS')}}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row  m-0 h-100">
                            <div class="col-12">
                                <div class="row p-2">
                                    <div class="col-12 p-0"> 
                                        <ul class="customList p-0" id="5">
                                            <template v-for="i in customFields" :key="i._id ? i._id.$oid : i.name">
                                                <li class="d-flex box-shadow bg-white border-radius-4 mt-2" :id="i._id ? i._id.$oid : ''" v-if="i.domain===4">
                                                    <div class="col-10 p-2 float-left" data-toggle="modal" data-target="#updateCustomField" @click="updateCustomFieldSettings(i._id.$oid,i.name,i.field_type,i.options)">
                                                        <p class="f-13 btn-click mb-1" :title="i.name">{{filterName(i.name)}}</p>
                                                        <label class="f-13 float-left color-gray">{{typeConvert(i, $ml)}}</label>
                                                    </div>
                                                    <div class="col-2 p-2 pt-2 d-flex align-items-center deleteIcon">
                                                        <i @click="deleteId=i._id.$oid" data-toggle="modal" data-target="#deleteCustomField" class="fa fa-close btn-click"></i>
                                                    </div>
                                                </li>
                                            </template>
                                        </ul>
                                    </div>
                                </div>                             
                            </div>
                        </div>                     
                    </div>
                </div>
            </div>
        </div>
        <!-- Add CustomField -->
        <div class="modal fade" id="addCustomField" ref="vuemodal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:615px!important">
               <div class="modal-content mcBgGrey">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">{{$ml.get('ADD_SPEACIAL_AREA')}}</h5>
                    <button type="button" class="close font-40" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-6">
                            <label class="new-label">{{$ml.get('SPECIAL_AREA_NAME')}}</label>
                            <div>
                                <input type="text" v-model="name" class="new-input mb-3" />
                                <div v-if="this.field===7||this.field===6">
                                    <div class="input-group mb-3">
                                        <input type="text" class="form-control" v-model="optionName" :placeholder="$ml.get('ENTER_OPTION')" :aria-label="$ml.get('ENTER_OPTION')" aria-describedby="basic-addon2" @keyup.enter="addOptionToSaveList()">
                                        <div class="input-group-append">
                                            <button class="btn btn-success" type="button" @click="addOptionToSaveList()">{{$ml.get('ADD')}}</button>
                                        </div>
                                    </div>
                                    <label class="new-label" v-show="saveOptionList.length>0">{{$ml.get('OPTIONS')}}</label>
                                    <div class="optionsList">
                                        <ul class="list-group list-group-flush">
                                            <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(option,index) in saveOptionList" v-bind:key="index">
                                                {{option}}
                                                <span class="badge badge-danger badge-pill" @click="removeOptionFromSaveList(index)">x</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="domain col-12 activityGroupButton"  role="group" aria-label="activityGroupButton">
                            <button type="button" :class="{active:domain == 1}" @click="domain=1,activityElement=false" class="btn">{{$ml.get('OPPORTUNITIES')}}</button>
                            <button type="button" :class="{active:domain == 5 || domain==6||domain==7||domain==8}" @click="domain=6,activityElement= !activityElement" class="btn">{{$ml.get('ACTIVITIES')}}</button>
                            <button type="button" :class="{active:domain == 2}" @click="domain=2,activityElement=false" class="btn">{{$ml.get('COMPAINES')}}</button>
                            <button type="button" :class="{active:domain == 3}" @click="domain=3,activityElement=false" class="btn">{{$ml.get('PERSONS')}}</button>
                            <button type="button" :class="{active:domain == 4}" @click="domain=4,activityElement=false" class="btn">{{$ml.get('PRODUCTS')}}</button>
                        </div>
                        <div v-if="activityElement" class="subDomain col-12 activityGroupButton"  role="group" aria-label="activityGroupButton">
                            <button type="button" :class="{active:domain == 6}" @click="domain=6" class="btn">{{$ml.get('CALL')}}</button>
                            <button type="button" :class="{active:domain == 5}" @click="domain=5" class="btn">{{$ml.get('TASK')}}</button>
                            <button type="button" :class="{active:domain == 8}" @click="domain=8" class="btn">{{$ml.get('APPOINTMENT')}}</button>
                            <button type="button" :class="{active:domain == 7}" @click="domain=7" class="btn">{{$ml.get('EMAIL')}}</button>
                        </div>
                        <div class="col-12"><hr/></div>
                    </div>
                    <div class="row">
                        <div class="fieldType btn-group btn-group-sm light-blue-border field filter-grup col-12"  role="group" aria-label="activityGroupButton">
                            <button type="button" @click="field=1" :class="{active:field == 1}" class="btn"><i class="fa fa-text-width f-21"></i><br><label>{{$ml.get('TEXT')}}</label></button>
                            <button type="button" @click="field=2" :class="{active:field == 2}" class="btn"><i class="fa fa-sort-numeric-asc f-21"></i><br><label>{{$ml.get('DIGITAL')}}</label></button>
                            <button type="button" @click="field=5" :class="{active:field == 5}" class="btn"><i class="fa fa-dollar f-21"></i><br><label>{{$ml.get('MONEY')}}</label></button>
                            <button type="button" @click="field=7,clearOptionList()" :class="{active:field == 7}" class="btn"><i class="fa fa-list f-21"></i><br><label>{{$ml.get('MULTIPLE_SELECTION')}}</label></button>
                            <button type="button" @click="field=6,clearOptionList()" :class="{active:field == 6}" class="btn"><i class="fa fa-list-alt f-21"></i><br><label>{{$ml.get('SINGLE_SELECTION')}}</label></button>
                        </div>
                        <div class="fieldType btn-group btn-group-sm light-blue-border field2 filter-grup col-12"  role="group" aria-label="activityGroupButton">
                            <button type="button" @click="field=4" :class="{active:field == 4}" class="btn"><i class="fa fa-user f-21"></i><br><label>{{$ml.get('USER')}}</label></button>
                            <button type="button" @click="field=8" :class="{active:field == 8}" class="btn"><i class="fa fa-building-o f-21"></i><br><label>{{$ml.get('ESTABLISHMENT')}}</label></button>
                            <button type="button" @click="field=9" :class="{active:field == 9}" class="btn"><i class="fa fa-user f-21"></i><br><label>{{$ml.get('PERSON')}}</label></button>
                            <button type="button" @click="field=10" :class="{active:field == 10}" class="btn"><i class="fa fa-phone f-21"></i><br><label>{{$ml.get('PHONE')}}</label></button>
                            <button type="button" @click="field=3" :class="{active:field == 3}" class="btn"><i class="fa fa-calendar f-21"></i><br><label>{{$ml.get('DATE')}}</label></button>
                        </div>
                        <div v-if="domain==4" class="fieldType btn-group btn-group-sm light-blue-border field2 filter-grup col-12"  role="group" aria-label="activityGroupButton">
                            <button type="button" @click="field=12" :class="{active:field == 12}" class="btn"><i class="fas fa-percentage f-21"></i><br><label>{{$ml.get('TAX')}}</label></button>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="row">
                        <div class="col-12 dealBtnStyle">
                            <button @click="saveButton" class="btn-new save">{{$ml.get('SAVE')}}</button>
                            <button @click="doSomethingOnHidden" class="btn-new ">{{$ml.get('CANCEL')}}</button>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <!-- Update CustomField -->
        <div class="modal fade" id="updateCustomField" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">{{$ml.get('EDIT_SPEACIAL_AREA')}}</h5>
                <button type="button" class="close font-40" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <label class="new-label">{{$ml.get('SPECIAL_AREA_NAME')}}</label>
                        <div>
                            <input type="text" v-model="updateName" class="new-input mb-3" />
                            <div v-if="this.updateField===7||this.updateField===6">
                                <div class="input-group mb-3">
                                    <input type="text" class="form-control" v-model="optionName" :placeholder="$ml.get('ENTER_OPTION')" :aria-label="$ml.get('ENTER_OPTION')" aria-describedby="basic-addon2" @keyup.enter="addOptionToUpdateList()">
                                    <div class="input-group-append">
                                        <button class="btn btn-success" type="button" @click="addOptionToUpdateList()">{{$ml.get('ADD')}}</button>
                                    </div>
                                </div>
                                <label class="new-label" v-show="updateOptionList.length>0">{{$ml.get('OPTIONS')}}</label>
                                <div class="optionsList">
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(option,index) in updateOptionList" v-bind:key="index">
                                            {{option.label}}
                                            <span class="badge badge-danger badge-pill" @click="removeOptionFromUpdateList(index)">x</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer dealBtnStyle">
                <button type="button" class="btn-new" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                <button type="button" class="btn-new save" @click="updateCustomField">{{$ml.get('EDIT')}}</button>
            </div>
            </div>
        </div>
        </div>
        <!-- Delete CustomField -->
        <div class="modal fade" id="deleteCustomField" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title f-w-normal font-family-bold f-14" id="exampleModalLongTitle">{{$ml.get('REALLY_DELETE_QUESTION')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-footer dealBtnStyle">
                        <button type="button" class="btn btn-new" data-dismiss="modal">{{$ml.get('NO')}}</button>
                        <button type="button" class="btn btn-new save"  @click="deleteCustomField" >{{$ml.get('YES')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import {mapActions} from 'vuex'
import axios from 'axios'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker)
import _ from 'underscore'
export default {
  name: 'addCustomField',
  data () {
        return {
            customFields:[],
            users:[],
            domain:1,
            field:1,
            updateField:"",
            updateFieldId:"",
            name:"",
            updateName:"",
            saveOptionList:[],
            updateOptionList:[],
            activityElement:false,
            productElement:false,
            items:[],
            isHiddenOrganization:false,
            isHiddenContact:false,
            deleteId:"",
            isActive: false,
            selected: undefined,
            optionName:""
        }
    },
    computed: {
        ...mapState([
            'baseUrl'
        ]),
    },
    methods:{
        typeConvert: function (value,ml) {
            const mlInst = ml || this.$ml;
            let typeArray=[]
            typeArray[1]=mlInst.get("TEXT")
            typeArray[2]=mlInst.get("DIGITAL")
            typeArray[3]=mlInst.get("DATE")
            typeArray[4]=mlInst.get("USER")
            typeArray[5]=mlInst.get("MONEY")
            typeArray[6]=mlInst.get("SINGLE_SELECTION")
            typeArray[7]=mlInst.get("MULTIPLE_SELECTION")
            typeArray[8]=mlInst.get("ESTABLISHMENT")
            typeArray[9]=mlInst.get("PERSON")
            typeArray[10]=mlInst.get("PHONE")
            typeArray[11]=mlInst.get("DATE_RANGE")
            typeArray[12]=mlInst.get("TAX")
            return (value && typeArray[value.field_type]) || ''
        },
        filterName:function(value){
            if ( value && value.length > 10 ) {
                return value.substring(0,10) + '...'
            } else {
                return value || ''
            }
        },
        ...mapActions([
            'updateLoading'
        ]),
        addOptionToUpdateList(){
            var optObj={}
            optObj['label']=this.optionName
            this.updateOptionList.push(optObj)
            this.optionName =''
        },
        addOptionToSaveList(){
            this.saveOptionList.push(this.optionName)
            this.optionName =''
        },
        removeOptionFromUpdateList(index){
            this.updateOptionList.splice(index,1)
        },
        removeOptionFromSaveList(index){
            this.saveOptionList.splice(index,1)
        },
        updateCustomFieldSettings(updateFieldId,updateName,updateField,updateOptions){
            this.updateFieldId=updateFieldId
            this.updateName=updateName
            this.updateField=updateField
            this.updateOptionList=updateOptions
            
        },
        clearOptionList(){
            this.saveOptionList = []
        },
        updateCustomField(){
            
             
            axios({
            method:'POST',
            url:'/updateCustomField',
            baseURL: this.baseUrl,
            data: {
                name:this.updateName,
                fieldId:this.updateFieldId,
                options:this.updateOptionList,
            },
            withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.getCustomFields()
                    $("#updateCustomField").modal("hide");
                     
                }else{
                     
                }
            })
        },
        getCustomFields(){
             
            axios({
                method:'POST',
                url:'/getCustomFields',
                baseURL: this.baseUrl,
                data: {
                    domain:0,
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.customFields=res.data.content.customFields
                    this.users=res.data.users
                     
                }else{
                     
                }
            })
        },
        saveButton(){
            if(this.name==="" || this.domain==="" || this.field===""){
                return false
            }

             
            axios({
                method:'POST',
                url:'/addCustomField',
                baseURL: this.baseUrl,
                data: {
                    name:this.name,
                    domain:this.domain,
                    fieldType:this.field,
                    options:this.saveOptionList
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.getCustomFields()
                    $("#addCustomField").modal("hide");
                    this.clearOptionList()
                     
                }else{
                     
                }
                
            })
        },
        deleteCustomField(){
             
            axios({
                method:'POST',
                url:'/deleteCustomField',
                baseURL: this.baseUrl,
                data: {
                    fieldId:this.deleteId,
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.getCustomFields()
                    $("#deleteCustomField").modal("hide");
                     
                }else{
                     
                }
            })
        },
        doSomethingOnHidden(){
            this.field=1
            this.name=""
            this.domain=1
            $("#addCustomField").modal("hide")
        }
    },
    mounted(){
        $(this.$refs.vuemodal).on("hidden.bs.modal", this.doSomethingOnHidden)
    },
    created(){
        this.getCustomFields()
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-20{
    width: 20%!important;
    border-right: 0.5px solid #AFC2D9;
}
ul.customList{
  min-height: 100vh;
}
.customList li {
  list-style: none;
  width: 100%;
}
.domain .active{
    background-color: #3767a0;
    color: white;
}
.subDomain  .active{
    background-color: #3767a0;
    color: white;
}
.fieldType .active{
    background-color: #3c89d8;
    color: white;
}
.fieldType .active i:before{
    color: white!important;
}
.field{
    height: auto;
}
.field button{
    width: 95px;
    border-bottom: 1px solid #3767a0!important;
}
.field button:first-child{
    border-bottom-left-radius: 0px!important;
}
.field button:last-child{
    border-bottom-right-radius: 0px!important;
}
.field2 button:first-child{
    border-top-left-radius: 0px!important;
}
.field2 button:last-child{
    border-top-right-radius: 0px!important;
}
.field2{
    height: auto;
}
.field2 button{
    width: 95px;
    border-top: 0px solid!important;
}
.settigsLeftMenu label:first-child{
    width:30px;
    height:30px;
    position:relative;
    z-index:5;
    background-color: white;
    border:1.4px solid #3767a0;

}

.settigsLeftMenu.active label {
    background-color: #3767a0;
    border:1.4px solid white;
}
.settigsLeftMenu.active i:before{
    color: white!important;
}

.settigsLeftMenu label:last-child{
    margin-left:-12px;
    padding-left: 14px;
    z-index:4;
    height:30px;
    padding-right: 8px;
    border:1.4px solid #3767a0;
    min-width: 140px;
    width: auto;
}
.settigsLeftMenu .active label:last-child{
    margin-left:-12px;
}

.list-underline-40 div{
    border-bottom:1px solid #3767a040;
}

.list-underline-80 li{
    border-bottom:1px solid #3767a080;
}

.settigsUl li{
    font-family: "font-family-regular";
    font-size: 14px;
}

.filter-grup button {
    font-size: 14px!important;
    font-family: "font-family-regular";
    background-color: white;
    border: 1px solid #3c89d8;
    width: 20%;
    padding: 17px 0;
    color: #A0A0A6;
}


.addCustomFieldArea{
    background-color: #FAFAFA;
    border: 0.5px solid #AFC2D9;
    border-radius: 4px;
    overflow: hidden;
}
.customList li{
    border: 0.5px solid transparent;
}
.customList li:hover{
    background: #F5F7FA !important;
    border: 0.5px solid #1991EB;
}

.customList li:hover .deleteIcon{
    opacity: 1;
}

.deleteIcon{
    opacity: 0;
    transition: 0.3s;
}

.activityGroupButton button {
    color: #6a6b75;
    background-color: transparent;
}

.optionsList{
    height: auto;
    max-height: 200px;
    overflow-y: auto;
}
.form-control:focus{
    box-shadow: none;
    border: 1px solid #1991EB
}
@media (max-width: 768px){
   
    .text-center{
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px !important;

    }
    .customFieldTable{
        width: 200%;
    }
    .addCustomFieldArea{
        overflow-x: auto !important;
        overflow-y: hidden !important;
    }
}
</style>
